// import TweenLite from './vendor/TweenLite';
import Preloader from './preloader';
import Questions from './questions';
import Results from './results';

let Application = function (params) {
  if (Application.prototype._singletonInstance) {
    return Application.prototype._singletonInstance;
  }
  Application.prototype._singletonInstance = this;

  this.initialize(params);
};

Application.prototype.initialize = function (params) {
  // console.log('Application initalizing ' + params);

  Application.tweenLength = 0.5;
  Application.tweenStagger = "-=0.25";

  /**
   *
   */
  let self = this;
  this.preloader = new Preloader({});
  this.questions = new Questions();
  this.results = new Results({});

  // Current screen/state info
  // preloader, questions, results
  this.currentState = "preloader";

  // Scoring info
  // array of html element ids that have data attributes that are used to calculate final results
  this.answers = [];
  this.score_ts1 = 0;
  this.score_tsi2 = 0;
  this.score_tsi3 = 0;
  this.score_ts4 = 0;

  this.preloaderClosed = function () {
    // this.intro.open();
    this.currentState = "questions";
    document.getElementById('content').style.display = 'block';
    this.questions.open();
  };

  this.questionsClosed = function (direction) {
    console.log('questionsClosed!');
    this.scrollToTopOfPage();
    this.results.open();
    // if ( direction > 0 ) {
    //   // next question or results
    //   this.currentQuestion++;
    // } else {
    //   // previous question or intro
    //   this.currentQuestion--;
    // }
    // console.log('Application.questionClosed opening question ' + this.currentQuestion);
    // // console.log('this.currentQuestion === 0 ' + (this.currentQuestion === 0));
    // this.scrollToTopOfPage();
    // if (this.currentQuestion === 0) {
    //   this.intro.open();
    // } else if (this.currentQuestion === this.totalQuestions + 1) {
    //   //show results
    //   // console.log("TODO RESULTS");
    //   this.results.open();
    //   this.currentState = "results";
    //   // this.currentQuestion = 0;
    //   // this.intro.open();
    //
    // } else {
    //   this.questions[this.currentQuestion - 1].open();
    // }
  };

  this.calculateResults = function () {
    this.score_ts1 = 0;
    this.score_tsi2 = 0;
    this.score_tsi3 = 0;
    this.score_ts4 = 0;

    let value1 = this.questions.slider1.getValue();
    let value2 = this.questions.slider2.getValue();
    let value3 = this.questions.slider3.getValue();
    let value4 = this.questions.slider4.getValue();

    let element1 = document.getElementById('q1-answer' + value1);
    let element2 = document.getElementById('q2-answer' + value2);
    let element3 = document.getElementById('q3-answer' + value3);
    let element4 = document.getElementById('q4-answer' + value4);
    let elements = [element1, element2, element3, element4];

    let element;
    for (let x = 0; x < elements.length; x++) {
      element = elements[x];
      // console.log(element.id + " ts1 " + parseInt(element.getAttribute('data-ts1'), 10));
      // console.log(element.id + " tsi2 " + parseInt(element.getAttribute('data-tsi2'), 10));
      // console.log(element.id + " tsi3 " + parseInt(element.getAttribute('data-tsi3'), 10));
      // console.log(element.id + " ts4 " + parseInt(element.getAttribute('data-ts4'), 10));
      this.score_ts1 += parseInt(element.getAttribute('data-ts1'), 10);
      this.score_tsi2 += parseInt(element.getAttribute('data-tsi2'), 10);
      this.score_tsi3 += parseInt(element.getAttribute('data-tsi3'), 10);
      this.score_ts4 += parseInt(element.getAttribute('data-ts4'), 10);
    }

    console.log('Score recap:');
    console.log('ts1: ' + this.score_ts1);
    console.log('tsi2: ' + this.score_tsi2);
    console.log('tsi3: ' + this.score_tsi3);
    console.log('ts4: ' + this.score_ts4);

    let scores = { 'ts1' : this.score_ts1, 'tsi2' : this.score_tsi2, 'tsi3' : this.score_tsi3, 'ts4' : this.score_ts4 };
    let sortedScores = Object.keys(scores).sort(function(a,b){return scores[b]-scores[a]});
    console.log("final sorted score results: ", sortedScores);
    return sortedScores;
  };

  this.reset = function() {
    this.currentState = "questions";
    document.getElementById('content').style.display = 'block';
    this.questions.open();
    this.scrollToTopOfPage();
  };

  this.scrollToTopOfPage = function() {
    try {
      window.scrollTo({
        top: 0,
        behavior: 'auto'
      });
    } catch(e) {
      console.log('scroll to top error');
    }
    try {
      window.parent.parent.scrollTo({
        top: 0,
        behavior: 'auto'
      });
    } catch(e) {
      console.log('scroll to top error');
    }
  };

};

export default Application;

